
















import { Component, Vue, Prop } from 'vue-property-decorator';
import { getCompanyAllDepartments, companyAllDepartments } from '@/utils/department';

type IDepartmentInfo = IDepartment.IResponse.IDepartmentInfo;

@Component
export default class SelectDepartment extends Vue {
  @Prop({default: () => []}) private excludeIds!: string[];
  private defaultOptions: IDepartmentInfo[] = [];
  get options() {
    return this.defaultOptions.filter((role) => !this.excludeIds.includes(role.id));
  }
  private created() {
    this.initOptions();
  }
  private initOptions() {
    if (companyAllDepartments.length === 0) {
      getCompanyAllDepartments().then(() => {
        this.defaultOptions = companyAllDepartments;
      }).catch((err) => {
        this.$message.warning(err);
      });
    } else {
      this.defaultOptions = companyAllDepartments;
    }
  }
  // 处理选项改变
  private handleChange(value: string) {
    this.$emit('change', value);
  }
}
